import { Chip } from '@mui/material';
import React from 'react';

import StackedIcon from '@components/Icon/StackedIcon';

import { getObservationConfig } from '@constants/fhir';

import useReferenceRange from '@hooks/useReferenceRange';

import type { ParameterModel, ReferenceRangeRiskLevel } from 'generated/types';

interface ReferenceRangeChipProps {
  /** Metric code */
  code: string;
  /** Risk of reference range */
  risk: ReferenceRangeRiskLevel;
  /** Metric parameters */
  parameters: ParameterModel[];
  /** Customized label of chip */
  label?: string;
}

export default function ReferenceRangeChip({
  code,
  parameters,
  risk,
  label,
}: ReferenceRangeChipProps) {
  const { displayFriendlyRange, parameterMap } = useReferenceRange();
  const metric = getObservationConfig(code);

  const { colour, bgColour } = parameterMap[risk];

  const chipLabel =
    label ??
    displayFriendlyRange({
      code,
      parameters,
    });

  return (
    <Chip
      icon={
        <StackedIcon
          icons={(metric?.icon ?? []).map((i) => ({
            key: i.name,
            size: 'xl',
            type: 'fas',
            ...i,
            color: colour,
          }))}
        />
      }
      label={chipLabel}
      sx={{
        borderColor: colour,
        backgroundColor: bgColour,
        textTransform: 'none',
        '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
        },
        p: 0.5,
        width: 'fit-content',
        minHeight: 'fit-content',
      }}
      variant="outlined"
    />
  );
}
